var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFulfill99(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6558",
    "data-name": "Group 6558",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 132.026,
    height: 56,
    viewBox: "0 0 132.026 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3115",
    "data-name": "Rectangle 3115",
    width: 132.026,
    height: 56,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6557",
    "data-name": "Group 6557",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M309.292,71.2a5.566,5.566,0,0,0-2.207-2.483,7.42,7.42,0,0,0-3.585-1.241,6.911,6.911,0,0,0-5.237,1.38,5.924,5.924,0,0,0-2.482,4.688,6.432,6.432,0,0,0,1.379,5.1,6.128,6.128,0,0,0,4.412,2.345,6.787,6.787,0,0,0,4-.828,6.288,6.288,0,0,1-1.654,3.31,3.424,3.424,0,0,1-3.034.965,2.892,2.892,0,0,1-1.517-.552l-2.618,3.034a7.465,7.465,0,0,0,1.516.828,8.159,8.159,0,0,0,2.619.689,7.825,7.825,0,0,0,5.929-1.793,10.76,10.76,0,0,0,2.207-3.034,20.437,20.437,0,0,0,1.241-4.826,15.637,15.637,0,0,0-.965-7.585Zm-4.551,5.374a3.331,3.331,0,0,1-2.345.552,2.537,2.537,0,0,1-1.931-1.108,4.043,4.043,0,0,1-.552-2.207,2.887,2.887,0,0,1,.965-1.931,2.479,2.479,0,0,1,2.207-.552,3.086,3.086,0,0,1,2.069,1.108,3.246,3.246,0,0,1,.689,2.207,3.421,3.421,0,0,1-1.1,1.931",
    transform: "translate(-208.294 -47.481)",
    fill: "#323634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    d: "M361.084,71.2a5.568,5.568,0,0,0-2.207-2.483,7.424,7.424,0,0,0-3.585-1.241,6.912,6.912,0,0,0-5.237,1.38,5.926,5.926,0,0,0-2.483,4.689,6.433,6.433,0,0,0,1.38,5.1,6.126,6.126,0,0,0,4.412,2.345,6.786,6.786,0,0,0,4-.828,6.29,6.29,0,0,1-1.655,3.31,3.425,3.425,0,0,1-3.034.965,2.891,2.891,0,0,1-1.517-.552l-2.619,3.034a7.477,7.477,0,0,0,1.517.828,8.158,8.158,0,0,0,2.619.689,7.827,7.827,0,0,0,5.929-1.793,10.785,10.785,0,0,0,2.207-3.034,20.443,20.443,0,0,0,1.241-4.827c.276-3.172,0-5.653-.965-7.585Zm-4.551,5.378a3.329,3.329,0,0,1-2.344.552,2.538,2.538,0,0,1-1.931-1.108,4.048,4.048,0,0,1-.552-2.207,2.892,2.892,0,0,1,.966-1.931,2.477,2.477,0,0,1,2.207-.552,3.085,3.085,0,0,1,2.068,1.108,3.244,3.244,0,0,1,.69,2.207,3.415,3.415,0,0,1-1.108,1.931Z",
    transform: "translate(-244.778 -47.482)",
    fill: "#323634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M309.264,17.1l4.275-4.275S310.782,5.792,300.849,0l-4.276,4.275,4.964,4.964-1.108,1.108a25.936,25.936,0,1,0,2.9,2.9l1.108-1.108Zm-5.378,12.691A20.345,20.345,0,1,1,283.614,9.245a20.345,20.345,0,0,1,20.271,20.547",
    transform: "translate(-181.513)",
    fill: "#85c440"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M10.225,67.918a.362.362,0,0,1,.109.265v2.966a.373.373,0,0,1-.375.375H6.931a.138.138,0,0,0-.156.156V83.513a.373.373,0,0,1-.375.375H2.748a.373.373,0,0,1-.375-.375V71.68a.138.138,0,0,0-.156-.156H.375a.358.358,0,0,1-.265-.109A.359.359,0,0,1,0,71.149V68.183a.36.36,0,0,1,.109-.265.36.36,0,0,1,.265-.109H2.217a.138.138,0,0,0,.156-.156v-.687a6.311,6.311,0,0,1,.593-3.013,3.3,3.3,0,0,1,1.92-1.53,10.894,10.894,0,0,1,3.669-.39H9.742a.373.373,0,0,1,.375.375v2.529a.373.373,0,0,1-.375.375H8.711a2.22,2.22,0,0,0-1.514.453,2.179,2.179,0,0,0-.422,1.545v.344a.138.138,0,0,0,.156.156H9.96a.363.363,0,0,1,.265.109",
    transform: "translate(0 -43.691)",
    fill: "#323634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M52.8,81.807a.361.361,0,0,1,.265-.109h3.653a.373.373,0,0,1,.375.374v15.3a.373.373,0,0,1-.375.375H53.069a.373.373,0,0,1-.375-.375V96.31c0-.062-.021-.1-.062-.109s-.083.016-.125.078a4.5,4.5,0,0,1-3.872,1.686,5.475,5.475,0,0,1-3.9-1.436A5.255,5.255,0,0,1,43.2,92.5V82.072a.373.373,0,0,1,.375-.374H47.2a.373.373,0,0,1,.375.374v9.335a3,3,0,0,0,.671,2.03,2.319,2.319,0,0,0,1.858.78,2.462,2.462,0,0,0,1.748-.64,2.775,2.775,0,0,0,.843-1.67V82.072a.36.36,0,0,1,.109-.265",
    transform: "translate(-30.433 -57.549)",
    fill: "#323634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M101.3,83.8a.358.358,0,0,1-.109-.265V62.425a.373.373,0,0,1,.375-.375h3.653a.373.373,0,0,1,.374.375V83.531a.373.373,0,0,1-.374.375h-3.653a.359.359,0,0,1-.265-.109",
    transform: "translate(-71.281 -43.709)",
    fill: "#323634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M134.445,65.7a.362.362,0,0,1,.109.265v2.966a.373.373,0,0,1-.375.375h-3.029a.138.138,0,0,0-.156.156V81.3a.373.373,0,0,1-.375.375h-3.653a.373.373,0,0,1-.375-.375V69.466a.138.138,0,0,0-.156-.156h-1.842a.373.373,0,0,1-.375-.375V65.969a.373.373,0,0,1,.375-.375h1.842a.138.138,0,0,0,.156-.156v-.687a6.31,6.31,0,0,1,.593-3.013,3.3,3.3,0,0,1,1.92-1.53,10.888,10.888,0,0,1,3.669-.39h1.186a.373.373,0,0,1,.375.375v2.529a.374.374,0,0,1-.375.375h-1.03a2.22,2.22,0,0,0-1.514.453A2.179,2.179,0,0,0,131,65.095v.343a.138.138,0,0,0,.156.156h3.029a.362.362,0,0,1,.265.109m3.279-2.592a2.566,2.566,0,1,1,1.764.7,2.392,2.392,0,0,1-1.764-.7m-.375,18.452a.358.358,0,0,1-.109-.265V65.969a.373.373,0,0,1,.375-.375h3.653a.373.373,0,0,1,.375.375V81.3a.373.373,0,0,1-.375.375h-3.653a.358.358,0,0,1-.265-.109",
    transform: "translate(-87.502 -41.477)",
    fill: "#323634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M194.782,83.8a.358.358,0,0,1-.109-.265V62.425a.373.373,0,0,1,.375-.375H198.7a.373.373,0,0,1,.375.375V83.531a.373.373,0,0,1-.375.375h-3.653a.359.359,0,0,1-.265-.109",
    transform: "translate(-137.131 -43.709)",
    fill: "#323634"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M220.554,83.8a.358.358,0,0,1-.109-.265V62.425a.373.373,0,0,1,.375-.375h3.653a.373.373,0,0,1,.375.375V83.531a.373.373,0,0,1-.375.375H220.82a.359.359,0,0,1-.265-.109",
    transform: "translate(-155.285 -43.709)",
    fill: "#323634"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulfill99);
export default __webpack_public_path__ + "static/media/fulfill99.8a7301734e6a6f6549ebd1dd9498ab58.svg";
export { ForwardRef as ReactComponent };